import { c as _c } from "react/compiler-runtime";
/**
 * Shared event card shell — status-colored accent bar + background.
 * Used by LiveEvent (dashboard) and ArchiveEvent (archives).
 */

export const STATUS_STYLES = {
  success: {
    bg: 'bg-success-tint/40',
    border: 'border-ghost',
    accent: 'bg-success',
    card: '',
    pill: 'bg-success/10 text-success border border-success/20'
  },
  fail: {
    bg: 'bg-surface-1',
    border: 'border-ghost',
    accent: 'bg-ghost',
    card: '',
    pill: 'bg-surface-3 text-text-muted border border-ghost'
  },
  active: {
    bg: 'bg-danger-tint/50',
    border: 'border-ghost',
    accent: 'bg-danger',
    card: 'animate-[card-flash_3s_ease-in-out_infinite] motion-reduce:animate-none',
    pill: 'bg-danger/12 text-danger border border-danger/25 animate-[pill-flash_1.5s_ease-in-out_infinite] motion-reduce:animate-none'
  }
};
export default function EventCardLayout(t0) {
  const $ = _c(14);
  const {
    status,
    children,
    onClick,
    onMouseEnter,
    onMouseLeave,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const s = STATUS_STYLES[status] || STATUS_STYLES.active;
  const interactive = onClick ? "cursor-pointer hover:brightness-125 transition-[filter] duration-150" : "";
  const t2 = `event-card border ${s.border} ${s.bg} ${s.card} ${interactive} ${className}`;
  const t3 = onClick ? "button" : undefined;
  const t4 = onClick ? 0 : undefined;
  let t5;
  if ($[0] !== onClick) {
    t5 = onClick ? e => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onClick(e);
      }
    } : undefined;
    $[0] = onClick;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const t6 = `event-card-accent ${s.accent}`;
  let t7;
  if ($[2] !== t6) {
    t7 = <div className={t6} />;
    $[2] = t6;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  let t8;
  if ($[4] !== children || $[5] !== onClick || $[6] !== onMouseEnter || $[7] !== onMouseLeave || $[8] !== t2 || $[9] !== t3 || $[10] !== t4 || $[11] !== t5 || $[12] !== t7) {
    t8 = <article className={t2} onClick={onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} role={t3} tabIndex={t4} onKeyDown={t5}>{children}{t7}</article>;
    $[4] = children;
    $[5] = onClick;
    $[6] = onMouseEnter;
    $[7] = onMouseLeave;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
}